import axios, { AxiosResponse } from 'axios';
import requestsUrl from './requestsUrl';

const instance = axios.create({
  baseURL: requestsUrl.API_BASE_URL,
});

const responseBody = (response: AxiosResponse) => response.data;

export default {
  get: (url: string) => instance.get(url).then(responseBody),
  post: (url: string, body: unknown) => instance.post(url, body).then(responseBody),
  put: (url: string, body: unknown) => instance.put(url, body).then(responseBody),
  delete: (url: string) => instance.delete(url).then(responseBody),
};
